import React from 'react'
import Login from '../_components/auth/Login'
import "../_css/Login.css";

function LoginPage() {
  return (
    <Login />
  )
}

export default LoginPage